import { Platform } from "react-native";
import { ROUTE } from "../../routes";
import { StoreKey } from "../../configs/api";
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: heightX,
        width: widthX
    };
    if (Platform.OS === 'web') {
        // const dimensionEvent = new EventEmitter();
        // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
        //send message to parent iframe about dimension changes
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const goToInit = async (action, _datastore, { navigateWithClear, asyncStorage }) => {
    console.warn("**** goToInit Action Triggered ****", action);
    await asyncStorage.set(StoreKey.LEAD_TOKEN, null);
    await asyncStorage.set(StoreKey.U_DATA, null);
    await asyncStorage.set('isEligible', true);
    await navigateWithClear(ROUTE.CHECK_LIMIT_MFC_INIT);
};
